import {Route, Routes, useParams} from 'react-router-dom';
import Player from "./Player.tsx";

type AppProps = {
    previewToken?: string;
};

function getWindowPreviewToken(): string | undefined {
    const previewToken = new URLSearchParams(window.location.search).get('t')?.trim();
    return previewToken ? previewToken : undefined;
}

function App({previewToken: previewTokenProp}: AppProps) {
    const {urlCode} = useParams<{urlCode: string}>();
    const previewToken = previewTokenProp ?? getWindowPreviewToken();
    console.log('urlCode app', urlCode);

    return (
        <div id="container">
                <Routes>
                    <Route index element={
                        <div
                            className="App"
                        >
                            <Player urlCode={urlCode} previewToken={previewToken}/>
                        </div>
                    }>
                    </Route>
                    <Route path="*"
                           element={<div style={{color: 'black'}}><h1>404 Not Found</h1><p>The page you requested does not exist.</p></div>}/>
                </Routes>
        </div>
    )
}

export default App
